// @ando/i18n — Lingui catalogs + helpers
//
// Locale catalogs live in `src/locales/{it,en,fr,es,pt}/messages.po`.
// Compiled to TS via `pnpm extract` + `pnpm compile`.
//
// Implementation arrives Fase 1 (after Vite client bootstrap).
// Default locale: `it` (B2B italian-first).

export const SUPPORTED_LOCALES = ["it", "en", "fr", "es", "pt"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "it";
